export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A1128] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 pb-12 border-b border-white/10">
          <div className="mb-8 md:mb-0">
            <div className="flex items-center gap-3 mb-3">
              <img src="https://public.readdy.ai/ai/img_res/42ee9d89-5646-4cd0-bc98-3a78e4d86d67.png" alt="IMPORMANZ S A S" className="h-10 w-10 object-contain" />
              <span className="text-2xl font-bold">IMPORMANZ S A S</span>
            </div>
            <p className="text-gray-400">Securing Digital Freedom</p>
          </div>

          <div className="flex gap-4">
            <a href="#" className="w-12 h-12 rounded-full border-2 border-[#00D9FF] flex items-center justify-center hover:bg-[#00D9FF] hover:text-[#0A1128] transition-all duration-300 cursor-pointer">
              <i className="ri-twitter-x-line text-xl"></i>
            </a>
            <a href="#" className="w-12 h-12 rounded-full border-2 border-[#00D9FF] flex items-center justify-center hover:bg-[#00D9FF] hover:text-[#0A1128] transition-all duration-300 cursor-pointer">
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <a href="#" className="w-12 h-12 rounded-full border-2 border-[#00D9FF] flex items-center justify-center hover:bg-[#00D9FF] hover:text-[#0A1128] transition-all duration-300 cursor-pointer">
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a href="#" className="w-12 h-12 rounded-full border-2 border-[#00D9FF] flex items-center justify-center hover:bg-[#00D9FF] hover:text-[#0A1128] transition-all duration-300 cursor-pointer">
              <i className="ri-instagram-line text-xl"></i>
            </a>
          </div>
        </div>

        {/* Middle Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="font-bold text-lg mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Downloads
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('support')} className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Documentation
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Support</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('support')} className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Help Center
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Contact Us
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">
                  GDPR Compliance
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-[#00D9FF]/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <div>
              © 2025 IMPORMANZ S A S. All rights reserved.
            </div>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">Privacy Policy</a>
              <span>•</span>
              <a href="#" className="hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">Terms of Service</a>
              <span>•</span>
              <a href="#" className="hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">Cookie Settings</a>
              <span>•</span>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#00D9FF] transition-colors duration-300 cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
